import { createRouter, createWebHistory } from "vue-router";


const routes = [
    {
        path: "/",
        name: "main",
        component: () => import('./../views/Home/NewHome.vue')
    },
    {
        path: '/whiteListTable',
        name: "whiteListTable",
        component: () => import('./../views/Admin/UsersWhiteList.vue')
    },
    {
        path: "/staff/deactivated",
        name: "staff-deactivated",
        component: () => import('./../views/Staff/DeactivatedStaff.vue'),
        meta: { menuKey: '/staff' }
    },
    {
        path: "/admin/staff",
        name: "admin-staff",
        component: () => import('./../views/Staff/Staff.vue'),
        meta: { menuKey: '/staff' }
    },
    {
        path: "/staff",
        name: "staff",
        component: () => import('./../views/Staff/NewStaff.vue'),
        meta: { menuKey: '/staff' }
    },
    {
        path: "/staff/:id?/edit/:group_id?",
        name: "staff_edit",
        component: () => import("../feature/users/StaffForm.vue"),
        meta: { menuKey: '/staff' }
    },
    {
        path: "/staff/:id?/view",
        name: "staff_view",
        component: () => import("../feature/users/StaffForm.vue"),
        meta: { menuKey: '/staff' }
    },
    {
        path: "/company/:id?",
        alias: ["/company/create"],
        name: "company_edit",
        component: () => import('./../views/Company/Company.vue')
    },
    {
        path: "/organizations",
        name: "organizations",
        component: () => import('./../views/Company/Organizations.vue')
    },
    {
        path: "/groups",
        name: "groups",
        component: () => import('./../views/Group/NewGroups.vue'),
        meta: { menuKey: '/groups' }
    },
    {
        path: "/group/overview/:id",
        name: "group",
        component: () => import('../views/Group/Group.vue'),
        meta: { menuKey: '/groups' }
    },
    {
        path: "/group/edit/:id?",
        name: "group-page",
        component: () => import("../feature/group-control/forms/GroupForm.vue"),
        meta: { menuKey: '/groups' }
    },
    {
        path: "/group/:id",
        name: "single-group",
        component: () => import("../feature/group-control/tables/GroupPassingsTable.vue"),
        meta: { menuKey: '/groups' }
    },
    {
        path: "/test/question",
        name: "question-page",
        component: () => import("./../views/Test/Question.vue")
    },
    {
        path: "/test/question-type",
        name: "questiontype-page",
        component: () => import("./../views/Test/QuestionType.vue")
    },
    {
        path: "/test/question-group",
        name: "questiongroup-page",
        component: () => import("./../views/Test/QuestionGroup.vue")
    },
    {
        path: "/test/question/:id?/edit",
        name: "question-edit",
        component: () => import("../feature/testing/forms/QuestionForm.vue")
    },
    {
        path: "/test/question-type/:id?/edit",
        name: "question-type-edit",
        component: () => import("../feature/testing/forms/QuestionTypeForm.vue")
    },
    {
        path: "/test/question-group/:id?/edit",
        name: "question-group-edit",
        component: () => import("../feature/testing/forms/QuestionGroupForm.vue")
    },
    {
        path: "/test/passing",
        name: "passings",
        component: () => import("../views/Test/Passing.vue")
    },
    {
        path: "/test/passing/:id/edit",
        name: "pssing-edit",
        component: () => import("../feature/testing/forms/PassingEditForm")
    },
    {
        path: "/test/passing/create",
        name: "passing-create",
        component: () => import("../feature/testing/forms/PassingCreateForm")
    },
    {
        path: "/passing/:code",
        name: "testing",
        component: () => import("../views/Testing/Testing.vue")
    },
    {
        path: "/passing",
        name: "not_testing",
        component: () => import("../views/Testing/NotTestingPage.vue")
    },
    {
        path: "/profile",
        name: "profile",
        component: () => import("../feature/users/StaffForm.vue"),
        meta: { menuKey: '/staff' },
    },
    {
        path: "/subscription",
        name: "subscription",
        component: () => import("../views/Subscription/Subscription.vue")
    },
    {
        path: "/subscription/list",
        name: "subscription-list",
        component: () => import("../views/Subscription/SubscriptionList.vue")
    },
    {
        path: "/company_subscriptions/list",
        name: "subscription-companies",
        component: () => import("../views/Subscription/GivenSubscriptionList.vue")
    },
    {
        path: "/subscription/:id?/edit",
        name: "subscription-edit",
        component: () => import("../views/Subscription/SubscriptionForm.vue")
    },
    {
        path: "/analytics",
        name: "analytics",
        component: () => import("../views/Analytics/AnalyticsForm.vue")
    },
    {
        path: "/analytics/:name",
        name: "analytics_report",
        component: () => import("../views/Analytics/AnalyticsReport.vue"),
        meta: { menuKey: '/analytics' }
    },
    {
        path: "/excel",
        name: "excel",
        component: () => import("../views/Staff/ExcelStaff.vue")
    },
    {
        path: "/analytics/references",
        name: "analytic-references",
        component: () => import("../views/Analytics/ReferenceProfiles.vue")
    },
    {
        path: "/relations",
        name: "relations",
        component: () => import("../views/Relations/Relations.vue")
    },
    {
        path: "/orders",
        name: "orders",
        component: () => import("../views/Orders/Orders.vue")
    },
    {
        path: "/orders/create",
        name: "orders-create",
        component: () => import("../views/Orders/CreateOrders.vue")
    },
    {
        path: "/notifications/create",
        name: "notifications-create",
        component: () => import("../views/Notifications/CreateNotification.vue")
    },
    {
        path: "/notifications/options",
        name: "notifications-options",
        component: () => import("../views/Notifications/NotificationsOptions.vue")
    },
    {
        path: "/notifications/tests",
        name: "notifications-tests",
        component: () => import("../views/Notifications/NotificationSettings.vue")
    },
    {
        path: "/faq",
        name: "faq",
        component: () => import("../views/FAQ/FAQ.vue")
    },
    {
        path: "/partners",
        name: "partners",
        component: () => import("../views/Partners/Partners.vue")
    },
    {
        path: "/experts",
        name: "experts",
        component: () => import("../views/Partners/Experts.vue")
    },
    {
        path: "/reviews",
        name: "reviews",
        component: () => import("../views/Partners/Reviews.vue")
    },
    {
        path: "/partner/:id?",
        name: "partner",
        alias: ["/partner/create"],
        component: () => import("../views/Partners/PartnerCenter.vue")
    },
    {
        path: "/expert/:id?",
        name: "expert",
        alias: ["/expert/create"],
        component: () => import("../views/Partners/PartnerExpert.vue")
    },
    {
        path: "/review/:id?",
        name: "review",
        alias: ["/review/create"],
        component: () => import("../views/Partners/Review.vue")
    },
    {
        path: "/begin",
        name: "begin",
        component: () => import("../views/BeginWork/BeginWork.vue")
    },
    {
        path: "/control/instruments",
        name: "instruments",
        component: () => import("../views/Subscription/InstrumentsControl.vue")
    },
    {
        path: "/references/files",
        name: "references-files",
        component: () => import("../views/References/ReferencesFiles.vue")
    },
    {
        path: "/references/profiles",
        name: "references-list",
        component: () => import("../views/References/ReferencesList.vue")
    },
    {
        path: "/excel/references",
        name: "excel-references",
        component: () => import("../views/References/ExcelReferences.vue")
    },
    {
        path: "/profiles/report/:id?",
        name: "profiles-report",
        component: () => import("../views/Report/ProfileReport.vue"),
        meta: { menuKey: '/staff' },
    },
    {
        path: "/:product/:id/:nameProduct?",
        name: "product-report",
        component: () => import("../views/ProductGroupReport/ProductGroupReport.vue"),
    },
    {
        path: "/diary",
        name: "emotions-diary",
        component: () => import("../views/EmotionDiary/EmotionDiary.vue"),
    },
    {
        path: "/diary/analytics",
        name: "emotions-diary-analytics",
        component: () => import("../views/EmotionDiary/DiaryAnalytics.vue"),
    },
    {
        path: "/mood/tracker",
        name: "mood-tracker",
        component: () => import("../views/MoodTracker/MoodTrackerPage.vue"),
    },
    {
        path: "/library/list",
        name: "emotion-library",
        component: () => import("../views/EmotionLibrary/EmotionLibraryList.vue"),
    },
    {
        path: "/library/emotion/:emotion",
        name: "emotion-library-detail",
        component: () => import("../views/EmotionLibrary/EmotionDetail.vue"),
    },
    {
        path: "/new_reports/texts/",
        name: "new_reports_texts",
        component: () => import("../views/NewReports/ReportsTextList.vue"),
    },
    {
        path: "/new_reports_text/:id?/edit",
        name: "new_reports_texts_edit",
        component: () => import("../views/NewReports/ReportTextForm.vue"),
    },
    {
        path: "/personal",
        name: "personal_account",
        component: () => import("../views/PersonalAccount/MyDevelopment.vue"),
    },
    {
        path: "/my-development",
        name: "my_development",
        component: () => import("../views/Development/My-Development.vue"),
    },
    {
        path: "/my-orders",
        name: "my_orders",
        component: () => import("../views/MyOrders/MyOrders.vue"),
    },
    {
        path: "/instruments",
        name: "instruments",
        component: () => import("../views/Products/Instruments.vue"),
    },
    {
        path: "/courses",
        name: "courses",
        component: () => import("../views/Products/Courses.vue"),
    },
    {
        path: "/rating",
        name: "rating",
        component: () => import("../views/Products/Passings.vue"),
    },
    {
        path: "/detailed",
        name: "detailed",
        component: () => import("../views/Products/ExpandedPassings.vue"),
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
